// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"6473":"css/admin-app.6683","9211":"css/app.6683"}[chunkId] + ".css";
};